exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rankBg[data-v-00c804cb]{background:url(" + require("../../dist/bg01.jpg") + ");width:100%;height:100%;background-size:15%}.ulGroup[data-v-00c804cb]{width:100%;position:absolute;top:18%;left:0;background:url(" + require("../../dist/bg01.jpg") + ");background-size:15%}.ulGroup ul[data-v-00c804cb]{width:90%;margin:12px auto;border:1px solid #444;border-radius:5px;overflow:hidden;box-shadow:inset 0 0 12px hsla(0,0%,100%,.2)}.ulGroup ul li[data-v-00c804cb]{padding:9px 20px;font-size:15px;color:#ccc;border-bottom:1px solid #444;background:hsla(0,0%,100%,.03) url(" + require("../assets/images/arrow_icon.png") + ") no-repeat 95%;background-size:2.5%}.ulGroup ul li[data-v-00c804cb]:last-child{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-00c804cb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/singer.vue
// module id = 40
// module chunks = 0